import { Component, Input, OnInit } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { BaseControlComponent } from './base-control.component';

@Component({
    selector: 'app-radio-button-control',
    template: `<div class="app-pr1 app-pb1" [formGroup]="formGroup">
      <div>
        <b>{{ label | translation: translationRequest }} {{ isRequired ? '*' : '' }}</b>
      </div>
      <mat-radio-group
        aria-live="polite"
        [attr.aria-label]="ariaLabel"
        [formControlName]="formControlName"
        autocomplete="off"
        role="radiogroup"
        class="vert-group"
        >
        @for (item of items; track item) {
          <mat-radio-button
            class="app-pr2"
            [value]="!valueProperty ? item : item[valueProperty]"
            >{{ !labelProperty ? item : item[labelProperty] | translation: translationRequest }}</mat-radio-button
            >
          }
        </mat-radio-group>
        @if (hintLabel) {
          <div class="redio-hint">{{ hintLabel | translation: translationRequest }}</div>
        }
        <div>
          @if (formControl.invalid && formControl.touched) {
            <mat-error
              class="redio-error"
              >
              {{ errorMessage | translation: translationRequest }}
            </mat-error>
          }
        </div>
      </div>`,
    styles: [
        `
      .vert-group {
        display: flex;
        flex-direction: column;
      }
      .redio-hint {
        font-size: 12px;
        margin-left: 10px;
      }
      .redio-error {
        margin-left: 10px;
      }
    `,
    ],
    standalone: false
})
export class RadioButtonControlComponent
  extends BaseControlComponent
  implements OnInit
{
  @Input()
  items: any[];

  @Input()
  valueProperty: string;

  @Input()
  labelProperty: string;

  @Input()
  ariaLabel: string;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  constructor() {
    super();
  }

  ngOnInit(): void {}
}
